<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 0C12.415 0 16 3.585 16 8C16 12.415 12.415 16 8 16C3.585 16 0 12.415 0 8C0 3.585 3.585 0 8 0ZM8.4 12H7.6C7.269 12 7 11.731 7 11.4V9H4.6C4.269 9 4 8.731 4 8.4V7.6C4 7.269 4.269 7 4.6 7H7V4.6C7 4.269 7.269 4 7.6 4H8.4C8.731 4 9 4.269 9 4.6V7H11.4C11.731 7 12 7.269 12 7.6V8.4C12 8.731 11.731 9 11.4 9H9V11.4C9 11.731 8.731 12 8.4 12Z"
      fill="currentColor"
    />
  </svg>
</template>
<script>
export default {
  name: 'PlusIcon'
}
</script>
